import React from 'react';
import { createRoot } from 'react-dom/client';
import SearchModule from '../jsx/event-search-module.jsx';

if (document.getElementById('search-module-app') && typeof window.searchModuleProps !== 'undefined') {
  const root = createRoot(document.getElementById('search-module-app'));
  root.render(React.createElement(SearchModule, window.searchModuleProps, null));
}
